import { useQuery, useMutation } from '@tanstack/react-query';
import { queryClient } from 'lib/react-query';
import { getRole, getRoles, createRole, updateRole, getRolesByDept, hasAdminRole } from 'apis/master/rolesAPI';
import { useSnackbar } from 'notistack';

export const useRoles = (config = {}) => {
	return useQuery({
		...config,
		queryKey: ['roles'],
		queryFn: () => getRoles(),
	});
};

export const useRole = ({ roleId, config = {} }) => {
	return useQuery({
		...config,
		queryKey: ['role', roleId],
		queryFn: () => getRole({ roleId }),
	});
};

export const useRolesByDept = (departmentId, config = {}) => {
	return useQuery({
		...config,
		queryKey: ['roleByDept', departmentId],
		queryFn: () => getRolesByDept(departmentId),
	});
};

export const useCreateRole = (config = {}) => {
	const { enqueueSnackbar } = useSnackbar();

	return useMutation({
		onError: () => {
			enqueueSnackbar(`Something went wrong`, {
				variant: 'error',
			});
		},
		onSuccess: () => {
			queryClient.invalidateQueries('roles');
			enqueueSnackbar(`New Role Created Successfully`, {
				variant: 'success',
			});
		},
		...config,
		mutationFn: createRole,
	});
};

export const useUpdateRole = (config = {}) => {
	const { enqueueSnackbar } = useSnackbar();

	return useMutation({
		onError: () => {
			enqueueSnackbar(`Something went wrong`, {
				variant: 'error',
			});
		},
		onSuccess: data => {
			queryClient.invalidateQueries('roles');
			enqueueSnackbar(`Updated Successfully`, {
				variant: 'success',
			});
		},
		...config,
		mutationFn: updateRole,
	});
};

export const useAdminRole = (config = {}) => {
	return useQuery({
		...config,
		queryKey: ['adminRole'],
		queryFn: () => hasAdminRole(),
	});
};
